import { v4 as nanoid } from 'uuid'

import { BoardEntity } from '../../data/BoardEntity'
import { Board } from '../../model/Board'
import { VersionedEvent } from '../EventSourced'

export enum BoardEventKind {
  NewHand = 'poker:board:new_hand',
  DealtHoleCards = 'poker:board:dealt_hole_cards',
  DealtFlop = 'poker:board:dealt_flop',
  DealtTurn = 'poker:board:dealt_turn',
  DealtRiver = 'poker:board:dealt_river',
  Showdown = 'poker:board:showdown',
  BetsToPot = 'poker:board:bets_moved_to_pot',
  CreateSidePot = 'poker:board:create_sidepot'
}

export interface BoardEvent extends VersionedEvent {
  id: string
  timestamp: number
  kind: BoardEventKind
  board: BoardEntity
}

export class BoardEvents {
  static newHandEvent(board: Board) {
    return BoardEvents.createEvent(BoardEventKind.NewHand, board)
  }

  static dealtHoleCardsEvent(board: Board) {
    return BoardEvents.createEvent(BoardEventKind.DealtHoleCards, board)
  }

  static dealtFlop(board: Board) {
    return BoardEvents.createEvent(BoardEventKind.DealtFlop, board)
  }

  static dealtTurn(board: Board) {
    return BoardEvents.createEvent(BoardEventKind.DealtTurn, board)
  }

  static dealtRiver(board: Board) {
    return BoardEvents.createEvent(BoardEventKind.DealtRiver, board)
  }

  static showdown(board: Board) {
    return BoardEvents.createEvent(BoardEventKind.Showdown, board)
  }

  static betsToPot(board: Board) {
    return BoardEvents.createEvent(BoardEventKind.BetsToPot, board)
  }

  static createSidePot(board: Board) {
    return BoardEvents.createEvent(BoardEventKind.CreateSidePot, board)
  }

  static createEvent(eventKind: BoardEventKind, board: Board) {
    return <BoardEvent>{
      id: nanoid(),
      kind: eventKind,
      timestamp: Date.now(),
      board: BoardEntity.createFromBoard(board)
    }
  }
}
